<template>
    <div class="container">
        <div v-if="scanned">
            <div class="validationresults p-5" :class="validationclass">
                <h1 class="text-white">{{ validationtext }}</h1>

                <p v-if="validationinfo" class="lead mb-0">
                    <span v-html="validationinfo"></span>
                </p>
            </div>
        </div>

        <form method="post" @submit.prevent="submit">
            <div class="form-group form-group-lg">
                <input type="text" v-model="fields.barcode" class="form-control" placeholder="Scan een barcode of vul cijfers handmatig in..." autofocus @keyup="checkSubmit" :class="{ 'is-invalid' : errors.barcode }">
            </div>

            <button type="submit" class="btn btn-primary btn-lg btn-block" :disabled="submitting">Valideren</button>
        </form>
    </div>
</template>

<script>
    import { FormMixin } from './../mixins/FormMixin';

    export default {
        name: 'ScanTickets',
        mixins: [ FormMixin ],
        props: {
            event: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                scanned: false,
                submitting: false,
                validationclass: null,
                validationtext: null,
                validationinfo: null
            }
        },
        methods: {
            submit () {
                this.scanned = false;
                this.submitting = true;
                this.validationclass = null;
                this.validationtext = null;
                this.validationinfo = null;

                axios
                    .post('/admin/scan/' + this.event.id, this.fields)
                    .then(response => {
                        this.requestSuccess(response);

                        this.scanned = true;
                        this.validationclass = response.data.class;
                        this.validationtext = response.data.text;
                        this.validationinfo = response.data.info
                        this.submitting = false;
                    })
                    .catch(error => {
                        this.requestError(error);
                        this.submitting = false;
                    });
            },
            checkSubmit (e) {
                if (e.target.value.length === 13) {
                    if (! this.submitting) {
                        this.submit();
                    }
                }
            }
        }
    }
</script>
